import type {
    GmailMessageParsed,
    ImporterDateRange,
} from '~common/google-api/types'
import type { DEFAULT_INVOICE_KEYWORDS } from '~common/invoice-processing/crude-classification'
import type { DateRange } from './utils'
import { Email } from '~common/storage/email'

export type ImportStatus = 'idle' | 'running' | 'completed' | 'error'

export type LanguageKey = keyof typeof DEFAULT_INVOICE_KEYWORDS

export interface ImporterConfig {
    terms: string
    dateRange: ImporterDateRange
    selectedLanguages: LanguageKey[]
    /** Gmail list page size (max 500). Defaults to 500. */
    pageSize?: number
    resetProgress?: boolean
}

export interface ImportProgress {
    startedAt: number | null
    lastUpdatedAt: number | null
    errorMessage: string | null
    nextPageToken?: string
    status: {
        paused: boolean
        scan: ImportStatus
        import: ImportStatus
    }
    totalInvoiceCandidates: number
    invoiceCandidatesSeenThisRun: number
    actualInvoicesFoundThisRun: number
    invoiceCandidatesProcessedThisRun: number
    lastMessageTimestamp: number | null
}

export type PersistedImportState = ImportProgress & {
    config: ImporterConfig
}

export interface EmailSearchResult {
    /** If null, we've reached the end of the search space. */
    nextPageToken: string | null
    preProcessedEmails: GmailMessageParsed[]
    processedEmails: Email[]
}

export interface SearchProcessorConfig {
    stateFilePath: string
}

export type ImporterEmailSearchPageProcessor = (params: {
    terms: string
    pageSize: number
    dateRange: DateRange
    nextPageToken?: string
}) => Promise<EmailSearchResult>

// TODO-audit: this is not a type! Move to utils
// Helper function to determine if importer is running
export function isImporterRunning(progress: ImportProgress): boolean {
    return (
        progress?.status.import === 'running' ||
        progress?.status.scan === 'running'
    )
}
